
import makerjs from "makerjs";

function C38(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    D = Param[0].param,R = Param[1].param, R1 = Param[2].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       d = D * 1 * myZoom,
       r = R * 1 * myZoom, //大圆半径
       r1 = R1 * 1 * myZoom,//6个小圆半径
       
       
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       h=r*2,w=r*2,
       /**
        * sin60=Math.sqrt(3)/2
        * cos60=1/2
        * 
        */
       hd=d*Math.sqrt(3)/2,
       rd=r*Math.sqrt(3)/2,
       wd=d/2,
       x=r,y=r,glassH = h, glassW = w;


   if (d !== 0) {
       var TxtD = "D="+D;
   } if (r !== 0) {
    var TxtR = "R="+R;
}
   if (r1 !== 0) {
       var TxtR1 = "R1="+R1;
   }

   var drawAbnormalShapeC38 = {
       paths: { 
        "largeCircle": new makerjs.paths.Circle([r, r], r),      
        "smallHolesOne": new makerjs.paths.Circle([r+d, r], r1),     
        "smallHolesTwo": new makerjs.paths.Circle([r+d/2, r+hd], r1),     
        "smallHolesThree": new makerjs.paths.Circle([r-d/2, r+hd], r1),     
        "smallHolesFour": new makerjs.paths.Circle([r-d, r], r1),     
        "smallHolesFive": new makerjs.paths.Circle([r-d/2, r-hd], r1),     
        "smallHolesSix": new makerjs.paths.Circle([r+d/2, r-hd], r1),
       }
   };
   var drawAbnormalShapeC38MarkR = {
       paths: {
        "RLine": new makerjs.paths.Line([r, r], [r+r/2, r+rd]),
       }
   };
   var drawAbnormalShapeC38MarkD = {
       paths: {
        "DLine": new makerjs.paths.Line([r, r], [r+d, r]),
        "LeftShortline": new makerjs.paths.Line([r, r], [r, r- 2 * markShift]),
        "RightShortline": new makerjs.paths.Line([r+d, r], [r+d, r- 2 * markShift]),
       }
   };
   var drawAbnormalShapeC38MarkR1 = {
       paths: {
        // "BottomLine": new makerjs.paths.Line([x0, y0 - markShift], [x2, y2 - markShift]),
        // "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        // "BotmShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 - 2 * markShift]),
       }
  //  };
  
   }; 
   makerjs.model.addCaption(drawAbnormalShapeC38MarkR, TxtR, [r, r-2*markShift], [r+2*markShift, r-2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeC38MarkD, TxtD, [r, r- 2 * markShift], [r+d, r- 2 * markShift]);//长度文字 
   makerjs.model.addCaption(drawAbnormalShapeC38MarkR1, TxtR1, [r-d/2, r+hd], [r-d/2+2*markShift, r+hd]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeC38: drawAbnormalShapeC38,
      }
    };
    markers={
      models: {
        drawAbnormalShapeC38: drawAbnormalShapeC38,
        drawAbnormalShapeC38MarkR: drawAbnormalShapeC38MarkR,
        drawAbnormalShapeC38MarkD:drawAbnormalShapeC38MarkD,
        drawAbnormalShapeC38MarkR1:drawAbnormalShapeC38MarkR1
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default C38;